module.exports = __webpack_public_path__ + "media/social.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/social.jpg
// module id = 37
// module chunks = 0